import QuickInput from 'views/components/quickInput/QuickInput'
import QuickInputStyles from 'views/components/quickInput/QuickInput.scss'
import CopyButton from './CopyButton.hbs'

export default class CopyInput extends QuickInput {

    get events() {
        return {
            'click .js-copy': 'onClickCopyValue'
        }
    }

    initialize({
        copyLabel,
        type = 'url',
        isReadOnly = true
    }) {

        super.initialize({
            ...arguments[0],
            isReadOnly,
            type,
        })

        this.$el.append(CopyButton({
            Styles: QuickInputStyles,
            copyLabel
        }))

    }

    onClickCopyValue() {

        // iOS needs special care:
        // https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
        if (window.uaparser.getOS().name === 'iOS') {
            var el = this.inputElement[0]
            var editable = el.contentEditable
            var readOnly = el.readOnly
            el.contentEditable = true
            el.readOnly = false
            var range = document.createRange()

            range.selectNodeContents(el)
            var sel = window.getSelection()
            sel.removeAllRanges()
            sel.addRange(range)
            el.setSelectionRange(0, 999999)
            el.contentEditable = editable
            el.readOnly = readOnly
        } else {
            this.inputElement.trigger('select')
        }

        try {
            var copySuccess = document.execCommand('copy')
            if (copySuccess) {
                Backbone.View.layout.openStatus(
                    window.i18n.gettext('The link has been copied to your clipboard.'),
                    'success'
                )
            } else {
                throw new Error('Could not copy link to clipboard…')
            }
        } catch (e) {

            // Capture exception in sentry

            window.sentry.withScope(() => {
                window.sentry.captureException(e)
            })

            Backbone.View.layout.openStatus(
                window.i18n.gettext('We could not copy the link to your clipboard...')
            )
        }

    }

}
